<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item :to="`/`">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        ></b-icon>
      </b-breadcrumb-item>
      <b-breadcrumb-item active> View Drum Picking </b-breadcrumb-item>
    </b-breadcrumb>
    <br />
    <b-card title="View Drum Picking Detail">
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col cols="1">
            <b-button size="md" variant="primary" @click="goBack()"
              >Back</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2"><strong>Job Order</strong></b-col>
          <b-col>: {{ form.props? form.props.jobOrderNumber : ''}}</b-col>
        </b-row>
        <b-row>
          <b-col cols="2"><strong>Fetching</strong></b-col>
          <b-col>: {{ form.orderNumber ? form.orderNumber : "" }}</b-col>
        </b-row>
        <b-row v-if="form.props.babyDrumType == undefined">
          <b-col cols="2"><strong>Machine Name</strong></b-col>
          <b-col>: {{ machine? machine.name : ''}}</b-col>
        </b-row>
        <b-row v-if="form.props.babyDrumType != undefined">
          <b-col cols="2"><strong>Machine Name</strong></b-col>
          <b-col>: {{ station? station.name : '' }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="2"><strong>Created at</strong></b-col>
          <b-col>: {{ new Date(form.createdAt).toLocaleString() }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="2"><strong>Status</strong></b-col>
          <b-col>: {{ form.status == null ? "No Status" : form.status }}</b-col>
        </b-row>
        <b-row v-if="form.props.babyDrumType != undefined">
          <b-col cols="2"><strong>Pick List Number</strong></b-col>
          <b-col>: {{ form.props? form.props.pickListNumber : '' }}</b-col>
        </b-row>
        <b-row v-if="form.props.babyDrumType != undefined">
          <b-col cols="2"><strong>Baby Drum Type</strong></b-col>
          <b-col>: {{ form.props? form.props.babyDrumType : '' }}</b-col>
        </b-row>
        <b-row v-if="form.props.babyDrumType != undefined">
          <b-col cols="2"><strong>Baby Drum Size</strong></b-col>
          <b-col>: {{ form.props? form.props.babyDrumSize : '' }}</b-col>
        </b-row>
        <b-row v-if="form.status != 'Created'">
          <b-col cols="2"><strong>Picking Start Time</strong></b-col>
          <b-col>: {{ job? job.props.MDS : '' }}</b-col>
        </b-row>
        <b-row v-if="form.status != 'Created'">
          <b-col cols="2"><strong>Picking End Time</strong></b-col>
          <b-col>: {{ job? job.props.MDE : '' }}</b-col>
        </b-row>
        <b-row style="margin-top:10px">
          <b-col cols="12">
            <b-table
              v-if="form.props.babyDrumType == undefined"
              head-variant="dark"
              :fields="fieldsTable"
              :items="form.item"
              small
              responsive
            >
              <template #cell(action)="row">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="openPDF(row.item)"
                  style="margin-right:10px">
                  View Pdf
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { dateFormat } from "@/utils/utils.js";
export default {
  props: ["id"],
  data() {
    return {
      form: {},
      station: {},
      machine: {},
      job: {},
      index: 0,
      promptDrum: false,
      title: "",
      actionType: "",
      fieldsTable: [
        { key: "orderNumber", label: "Pick List" },
        { key: "pickList.orderNumber", label: "SO Number" },
        { key: "lineItemDescription", label: "Line Item And Description"},
        { key: "pickList.cableLengthInfo", label: "Cable Length" },
        { key: "pickList.fromBatch", label: "Drum" },
        { key: "pickList.cuttingNumber", label: "Cutting Number" },
        { key: "pickList.binLocation", label: "Bin Location" },
        { key: "action", label: "Action" },

      ],
    };
  },
  computed: {
    jobOrderById() {
      return this.$store.getters['joborder/getJobOrderId']
    },
  },
  methods: {
    ...mapActions({
      getJobOrder: "joborder/getJobOrder",
    }),
    goBack() {
      window.history.back()
    },
    openPDF(data) {
      if (data.pickList.pdfURL) {
        window.open(data.pickList.pdfURL, '_blank')
      }else{
        this.$bvToast.toast("No PDF available", {
          title: "No PDF available",
          variant: "danger",
          solid: true,
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch('fetch/getFetchDetailId', { id: this.id }).then((res) => {
    this.form = res
    this.form.item.map((item) => {
      (item.lineItemDescription = item.pickList.lineItem + "," + item.pickList.lineDescription);
      })

    if (this.form.props.babyDrumType != undefined){
      this.$store.dispatch("plant/getStationId", { id: this.form.props.station }).then((res) => {
        this.station = this.$store.getters['plant/getStationId'];
      })
    }

    this.$store.dispatch("plant/getStationId", { id: this.form.machine }).then((res) => {
    this.machine = this.$store.getters['plant/getStationId'];
    })


      this.$store.dispatch('joborder/getJobOrderId', {id: this.form.JobOrderID}).then((res) => {

        this.job = this.$store.getters['joborder/getJobOrderId'];
        
        var newMDS = dateFormat(this.job.props.MDS).split(",")
        var newMDE = dateFormat(this.job.props.MDE).split(",")

        this.job.props.MDS = newMDS[0] + newMDS[1].replace(/\./g, ':'),
        this.job.props.MDE = newMDE[0] + newMDE[1].replace(/\./g, ':')
      })

      if (this.form.props.babyDrumType == "W"){
        return this.form.props.babyDrumType = "Wooden"
      }
      else if (this.form.props.babyDrumType == "S"){
        return this.form.props.babyDrumType = "Steel"
      }
      if (this.form.props.babyDrumType == "A"){
        return this.form.props.babyDrumType = "Active"
      }
      else if (this.form.props.babyDrumType == "I"){
        return this.form.props.babyDrumType = "Inactive"
      }
    })
  },
};
</script>
